'use strict';

/* global jQuery */

import { $, $document, confirm } from '../../../src/globals.js';

const initConfirm = ( $container ) => {
	// init container
	if ( ! $container?.length ) {
		$container = $document;
	}

	$container.on( 'click', '.delete', function () {
		const target = $( this ).attr( 'href' );

		// confirm must be done on dedicated JS.
		if ( '#' === target || '' === target ) {
			return;
		}

		confirm().then( () => {
			window.location.href = target;
		} );

		return false;
	} );

	$container.on( 'submit', 'form', function ( ev ) {
		const $form = $( this ),
			action = $form.find( '[name="action"]' ).val(),
			confirmed = $form.hasClass( 'confirmed' );

		if ( 'delete' === action && ! confirmed ) {
			confirm().then( () => {
				$form.addClass( 'confirmed' ).submit();
			} );

			return false;
		}
	} );
};

export { initConfirm };
